import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vrybakk/Documents/Projects/clients/precisionpart-frontend/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vrybakk/Documents/Projects/clients/precisionpart-frontend/src/components/blocks/AccordionsBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vrybakk/Documents/Projects/clients/precisionpart-frontend/src/components/blocks/ParallaxHero.tsx");
